import { ProductImmersiveLine } from 'Components/lines/product-immersive-line/ProductImmersiveLine';
export default ProductImmersiveLine;
